import { render, staticRenderFns } from "./AlertBridgeComponent.vue?vue&type=template&id=1912f313"
import script from "./AlertBridgeComponent.vue?vue&type=script&lang=js"
export * from "./AlertBridgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports